export const COMPONENT_TITLE = {
  AuthentificationPage: 'Connexion',
  ImpersonatePage: 'Connectez-vous en tant que',
  AdminPage: 'Admin',
  ConfigurationManagementPage: 'Gestion des configurations',
  ConfigurationPage: 'Configuration',
  AccueilPage: 'Accueil',
  RoundPage: 'Tournée',
  OtDetailsPage: "Détails d'un OT",
  SitesListPage: 'Listes des sites',
  EquipementDetailsContentComponent: "Détails d'un équipement",
  OtCrListPage: 'Alertes',
  CrDetailsPage: "Détails d'un CR",
  CrActiviteInternePage: "Saisie de l'activité interne",
  CrListPage: 'CR Saisis',
  CrEditPage: 'Validation du CR',
  UnplannedOtPage: 'Saisir CR OT non planifié',
  CrSynthesePage: 'Synthèse des informations',
  SiteHomePage: "Détails d'un site",
  GftFilterPage: 'Filtres (GFT)',
  SiteAccessHomePage: "Conditions d'accès",
  SiteOtsTodoOrDonePage: 'OT à réaliser ou réalisés',
  SecuritePage: 'SECURITE',
  UserPage: 'Mon compte',
  SynchronisationPage: 'SynchronisationPage',
  CrtPage: 'CRT - Liste des sites',
  BandeauCommunicationPage: 'CRT - Bandeau de communication',
  CrtCollectingScopePage: 'CRT - Récuperation mode déconnecté',
  ObjectFilterPage: 'CRT - Page de filtre',
  DataDetailsPage: "CRT - Détail d'une donnée",
  SharedFilterPage: 'CRT - Filtre des données',
  CrtDataListPage: 'CRT - Liste des données',
  CrtHistoricListPage: 'CRT - Liste des historiques',
  EventDetailsPage: "CRT - Détail d'un événement",
  EventsListPage: 'CRT - Liste des événements',
  HistoricDataChartsPage: 'CRT - Courbe historique',
  CrtLrPhListPage: 'CRT - Liste des LR/PH',
  CrtLrDetailsPage: "CRT - Détail d'une LR",
  CrtLrDataListPage: "CRT - Liste des données d'une LR",
  CrtLrPage: "CRT - Affichage d'une LR graphique",
  CrtPhCalendar: "CRT - Calendrier d'un PH",
  CrtPhPage: 'CRT - PH',
  PhPopupReglagePage: 'CRT - PH popup de réglage',
  CrtPhDetailsPage: "CRT - Détail d'un PH",
  SendingScopePage: "CRT - Périmetre d'envois",
  SiteDetailsPage: "CRT - Détail d'un site",
  CrtSyntheticViewPage: 'CRT - Vue synthétique',
  HistoricGroupListPage: "CRT - Liste groupe d'historiques",
  EditHistoricGroupComponent: "CRT - Ajout/Modification groupe d'historiques",
  BlocageListComponent: 'CRT - Liste des blocages',
  AgendaVueJourComponent: 'Agenda - Vue Jour',
  AgendaVueMoisComponent: 'Agenda - Vue Mois',
  AgendaVueEquipeComponent: 'Agenda - Vue Equipe',
  AgendaSaisieIndispoComponent: 'Saisie indisponibilité immédiate',
  AidePage: 'Aide',
  IotPage: 'IoT - Périmètre de pose',
  IotBesoinPoseDetailComponent: "IoT - Détail d'un besoin de pose",
  IotBesoinPoseNewModal: "IoT - Création d'un besoin de pose",
  IotBesoinPoseListComponent: 'IoT - Liste des besoins de poses',
  IotCapteurActionPage: "IoT - Modal d'action sur un capteur (remplacement/suppression/depose)",
  CapteurCrPoseComponent: "IoT - Saisie d'un CR de pose",
  IotCapteurDetailPage: "IoT - Détail d'un capteur",
  IotCapteurListComponent: 'IoT - Liste des capteurs',
  IotCapteurNonPosePage: "IoT - Non pose d'un capteur",
  NewsIndisposListeComponent: 'News & Indisponibilités - Liste',
  DysfonctionnementPage: 'Déclarer un incident CRT',
};
